module.exports = __webpack_public_path__ + "img/counseling-providers.94add619.png";